import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import { SnackbarProvider } from 'notistack';
import apolloClient from '../lib/apolloClient';
import getMessages from '../lib/i18n/getMessages';
import configureStore from '../store/findBobPublicStore';
import SuccessionMessages from '../components/Succession/SuccessionMessages';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import SuccessionDrawerWithListener from './Succession/SuccessionDrawerWithListener';
import { CurrencyProvider } from '../hooks/useCurrency';

const SuccessionMessagesContainer = ({ current_user, company, messaging_metrics, features }, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  window.currency = railsContext && railsContext.currency;
  const locale = window.locale;

  // Redux store so the shared profile drawer (SuccessionDrawerWithListener) can
  // mount and be opened via `openSuccessionDrawer`, exactly like /succession/search
  // and ~13 other Succession bundles. Empty preloaded state: the drawer only reads
  // the `successionDrawer` slice (defaults to no selection) and fetches its own
  // user/profile data, so the messaging props don't belong in Redux state.
  const store = configureStore({});

  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || 'USD'}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
        <Provider store={store}>
          <ApolloProvider client={apolloClient}>
            <SuccessionMessages
              current_user={current_user}
              company={company}
              messaging_metrics={messaging_metrics}
              features={features}
            />
            {/* Shared profile drawer — same surface as /succession/search. Opened
                from messages by clicking a participant name (see ParticipantName).
                The drawer needs SuccessionThemeProvider (useSuccessionTheme) and
                SnackbarProvider (notistack enqueueSnackbar) in scope — it sits
                outside <SuccessionMessages>, which provides those internally. Same
                wrapping as HomeContainer and other drawer-hosting bundles. */}
            <SuccessionThemeProvider company={company} user={current_user}>
              <SnackbarProvider maxSnack={3}>
                <SuccessionDrawerWithListener />
              </SnackbarProvider>
            </SuccessionThemeProvider>
          </ApolloProvider>
        </Provider>
      </IntlProvider>
    </CurrencyProvider>
  );
};

export default SuccessionMessagesContainer;
